import { FileEntity } from '../fileEntity';

export enum LegalClientSourcesOfIncomeSourceType {
  ProfitFromMainActivities = 'ProfitFromMainActivities',
  InvestmentIncome = 'InvestmentIncome',
  Other = 'Other',
}

export enum LegalClientSourcesOfIncomeFinancialSourceType {
  LoansAndCreditFacilities = 'LoansAndCreditFacilities',
  InternalFundsOfCompany = 'InternalFundsOfCompany',
  Other = 'Other',
}

export interface LegalClientSourcesOfIncomeEntity {
  incomeSources: LegalClientSourcesOfIncomeSourceType[];
  otherIncomeSource?: string;

  financialSources: LegalClientSourcesOfIncomeFinancialSourceType[];
  otherFinancialSource?: string;

  files: FileEntity[];
}
